import React from 'react'

import * as S from './styles'

/**
 * @typedef {Object} CheckboxProps
 * @property {string | React.ReactNode} label 
 * @property {boolean} checked 
 * @property {boolean} [disabled] 
 * @property {(event: React.ChangeEvent<HTMLInputElement>) => void} onChange 
 */

/**
 * @param {CheckboxProps} props
 */
export default function Checkbox({ label, checked, disabled, onChange }) {
  return (
    <S.Checkbox
      disabled={disabled}
      label={label}
      checked={checked}
      onChange={onChange}
    />
  )
}
